<!-- src/components/Orders/OrdersList/OrderItemMenu.vue -->
<template>
  <actions-menu :dialogEdit="dialogEdit" :dialogEditUrl="orderId" :Id="Id" @click.stop="viewOrderDetails"
    :ShowDialogDelete="false" />
</template>

<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue";

export default {
  name: "OrderItemMenu",
  components: { actionsMenu },
  props: {
    orderId: {
      type: String,
      required: true,
    },
    getOrdersAfterDeleted: Function,
    Id: [String, Number],
    dialogEdit: {
      type: String,
      default: "OrderDetails",
    },
  },
  methods: {
    viewOrderDetails() {
      this.$emit('viewDetails');
    },
    activeDeletedSnackBar() {
      this.getParent('MainLayout').ActiveDeletedSnackBar();
    },
    activeWarningSnackBar() {
      this.getParent('MainLayout').ActiveWarningSnackBar();
    },
    getParent(name) {
      let p = this.$parent;
      while (p) {
        if (p.$options.name === name) {
          return p;
        } else {
          p = p.$parent;
        }
      }
      return null;
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
